import {useMemo} from 'react';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {formatMobileInfo} from '@/utils/help/mobile';

export const useMobileInfo = () => {
  const {isMobile} = useHelpContext();
  const mobileInfo = useMemo(() => formatMobileInfo(isMobile), [isMobile]);

  return mobileInfo;
};
